import type { Config } from '@puckeditor/core';

import { standalonePagePuckConfig } from '../standalone-page/puck-config';
import { PageRootRender } from '../components/page-root-render';

/**
 * Production Puck config for rendering published standalone pages.
 * Reuses all editor component definitions with the PageRootRender root
 * to handle header/navigation from page-level settings.
 */
export const standalonePageRenderConfig: Config = {
  ...standalonePagePuckConfig,
  root: {
    ...standalonePagePuckConfig.root,
    render: PageRootRender,
  },
};
